require('./src/js/angular-tooltips');
module.exports = '720kb.tooltips';
